/**
 * Created by showzyl on 2017/2/18.
 */

;(function (win) {
	'use strict';

	var mv_default_data = {
		"banner": "https://hybird.rayjump.com/dsp/img/fruit/banner_fruit.png",
		"brand_logo": "https://hybird.rayjump.com/dsp/img/fruit/cat.png",
		//"loading": "https://hybird.rayjump.com/dsp/img/fruit/begin_bg_360_640.jpg",
		"loading": "https://hybird.rayjump.com/dsp/img/fruit/begin_bg.jpg",
		"tapped_image": [
			'https://hybird.rayjump.com/dsp/img/fruit/hat.png',
			'https://hybird.rayjump.com/dsp/img/fruit/brain.png'
		],
		"not_tapped_image": "https://hybird.rayjump.com/dsp/img/fruit/bomb.png",
		"backgroud": "https://hybird.rayjump.com/dsp/img/fruit/game_bg.png",
		"score_backgroud": "https://hybird.rayjump.com/dsp/img/fruit/end-bg_360_640.jpg",
		"text": "This game is provided by Mobvista Company",
		"ios_cta_text": "ios",
		"ios_cta_url": "ios 链接",
		"gp_cta_text": "gp",
		"gp_cta_url": "gp_cta_url",
		"share_facebook": 1,
		"share_twitter": 1,
		"share_instagram": 1,
		"width": "320",
		// "height": "50"
	}
	
	// var mv_default_data = {
	// 	"banner": "../../img/fruit/banner_fruit.png",
	// 	"brand_logo": "../../img/fruit/cat.png",
	// 	//"loading": "../../img/fruit/begin_bg_360_640.jpg",
	// 	"loading": "../../img/fruit/begin_bg.jpg",
	// 	"tapped_image": [
	// 		'../../img/fruit/hat.png',
	// 		'../../img/fruit/brain.png'
	// 	],
	// 	"not_tapped_image": "../../img/fruit/bomb.png",
	// 	"backgroud": "../../img/fruit/game_bg.png",
	// 	"score_backgroud": "../../img/fruit/end-bg_360_640.jpg",
	// 	"text": "This game is provided by Mobvista Company",
	// 	"ios_cta_text": "ios",
	// 	"ios_cta_url": "ios 链接",
	// 	"gp_cta_text": "gp",
	// 	"gp_cta_url": "gp_cta_url",
	// 	"share_facebook": 1,
	// 	"share_twitter": 1,
	// 	"share_instagram": 1,
	// 	"width": "320",
	// 	"height": "50"
	// }

	var debug = true;
	var imgList;
	var imgLen;
	var score = 0;
	var duration = 20;
	var oScoreMap = {};
	var defaultClick = 'click';
	var ww;
	var wh;
	var Mouse = Stage.Mouse;
	var count = 0;
	var bStopGenerateObj = false;
	var bGameStart = false;
	var bStopTiming = false;
	var aTimeout = [];

	mv_data = _.extend(mv_default_data, mv_data);

	document.addEventListener('DOMContentLoaded', function (event) {
		mv_util.addClass(mv_util.getEl('#mv_page_init'), 'mv_none');
		mv_util.addClass(mv_util.getEl('.mv_mask')[0], 'mv_none');
		var data = handleData(mv_data);
		data.text = mv_util.unescapeHTML(data.text);

		handleRender(data, function () {
			gameStart();
		});

		bindEvent(data);

	});

	function handleData(data) {
		if (data && data.tapped_image.length && data.not_tapped_image) {
			data.tapped_image.push(data.not_tapped_image);
			imgList = data.tapped_image;
			imgLen = imgList.length;
			return data;
		}
	}

	function handleRender(data, cb) {
		var begin = mv_util.getEl('.mv_begin')[0];
		var lastpage = mv_util.getEl('.mv_lastpage')[0];
		var iconImg = mv_util.getEl('.mv_icon_img');
		var mv_btn_start = mv_util.getEl('.mv_btn_start')[0];
		var mv_stats = mv_util.getEl('.mv_stats');
		var text = mv_util.getEl('.mv_txt')[0];
		var mv_lastpage_share = mv_util.getEl('.mv_lastpage_share')[0];
		var tpl = mv_util.getEl('#mv_tpl').innerHTML;
		var banner = mv_util.getEl('#mv_banner');
		var mv_fruit = mv_util.getEl('#mv_fruit');
		var mv_begin = mv_util.getEl('.mv_begin')[0];
		var stats = mv_util.getEl('.mv_stats');

		// 统计
		mv_common.stats(stats);

		// only render banner
		if (data && mv_common.getTplSize(data)) {
			mv_util.createEl('img', banner, {
				src: data.banner
			});
		} else {
			mv_util.rmClass(mv_fruit, 'mv_none');
			mv_util.rmClass(mv_begin, 'mv_none');
		}

		if (data
			&& data.loading
			&& data.score_backgroud
			&& data.text
			&& data.brand_logo) {

			begin.style.backgroundImage = 'url(' + data.loading + ')';
			lastpage.style.backgroundImage = 'url(' + data.score_backgroud + ')';
			text.innerHTML = data.text;
			mv_util.addClass(mv_btn_start, 'mv_none');

			for (var i = 0; i < iconImg.length; i++) {
				iconImg[i].setAttribute('src', data.brand_logo);
			}

			// 渲染
			var sHtml = _.template(tpl)(data);
			mv_lastpage_share.innerHTML = sHtml;

			var device = mv_util.device();
			if (device.isiOS) {
				setTimeout(function () {
					mv_util.rmClass(mv_util.getEl('.mv_appstore')[0], 'mv_none');
				}, 1000)
			}
			if (device.isAndroid) {
				setTimeout(function () {
					mv_util.rmClass(mv_util.getEl('.mv_googleplay')[0], 'mv_none');
				}, 1000)
			}

			if (/rayjump/ig.test(location.href)) {
				mv_util.rmClass(mv_util.getEl('.mv_appstore')[0], 'mv_none');
				mv_util.rmClass(mv_util.getEl('.mv_googleplay')[0], 'mv_none');
			}

			// 分享
			mv_common.share(mv_data);

		}

		cb && cb();

	}

	function renderTime() {
		debug && console.log('renderTime: ', duration);
		var time = mv_util.getEl('.mv_time')[0];
		time.innerHTML = duration + 's';
	}

	function renderScore() {
		debug && console.log('score:', score);
		var scoreEl = mv_util.getEl('.mv_score')[0];
		scoreEl.innerHTML = score;
	}

	function renderClickScore(score) {
		var clickscore = mv_util.createEl('p', '', {
			className: 'mv_clickscore mv_fadeout',
			innerHTML: '+' + score
		});
		setTimeout(function () {
			//mv_util.rmEl(clickscore);
			clickscore.style.zIndex = '-9999';
		}, 1000);
	}

	function bomb() {
		var gameover = mv_util.getEl('.mv_gameover')[0];
		var txt = mv_util.getEl('.mv_gameover_txt')[0];

		mv_util.rmClass(gameover, 'mv_none');
		mv_util.rmClass(txt, 'mv_none');
		mv_util.addClass(gameover, 'mv_start');
		mv_util.addClass(txt, 'mv_fadein');

		var _timer = setTimeout(function () {
			mv_util.addClass(gameover, 'mv_none');
			mv_util.addClass(txt, 'mv_none');
		}, 2000);
		aTimeout.push(_timer);

		gameOverAnimation();

	}

	function gameOverAnimation(timeout) {
		var mv_falling = mv_util.getEl('#mv_falling');
		var begin = mv_util.getEl('.mv_begin')[0];
		var game = mv_util.getEl('.mv_game')[0];
		var lastPage = mv_util.getEl('.mv_lastpage')[0];

		mv_falling && mv_util.rmEl(mv_falling);
		mv_util.addClass(game, 'mv_none');
		mv_util.addClass(begin, 'mv_none');

		if(timeout){
			mv_util.rmClass(lastPage, 'mv_none');
			lastPageAnimation();
		}else{
			mv_util.rmClass(lastPage, 'mv_none');
			var _timer = setTimeout(function () {
				lastPageAnimation();
			}, 3000);
			aTimeout.push(_timer);
		}
	}

	function lastPageAnimation() {

		var lastscorebox = mv_util.getEl('.mv_lastscorebox')[0];
		var sharebox = mv_util.getEl('.mv_sharebox')[0];
		var install = mv_util.getEl('.mv_install')[0];

		var aLast = [{
			el: lastscorebox,
			time: 1000
		}, {
			el: sharebox,
			time: 2000
		}, {
			el: install,
			time: 3000
		}];

		_.each(aLast, function(item){
			var _timmer = setTimeout(function () {
				mv_util.addClass(item['el'], 'mv_fadein');
			}, item['time']);
			aTimeout.push(_timmer);
		});
	}

	function bindEvent(data) {
		var close_btn = mv_util.getEl('#mv_close_btn');
		var banner = mv_util.getEl('#mv_banner');
		var mv_fruit = mv_util.getEl('#mv_fruit');
		var mv_begin = mv_util.getEl('.mv_begin')[0];
		var btnstart = mv_util.getEl('.mv_btn_start')[0];

		banner.addEventListener(defaultClick, function () {
			mv_stats({
				category: 'Richmedia',
				action: 'click_fallobj_banner',
				label: data.width + '_' + data.height
			});
			try {
				mraid.expand();
				mraid.setOrientationProperties({
					'allowOrientationChange': false,
					'forceOrientation': 'portrait'
				});
			} catch (e) {

			}
			mv_util.addClass(banner, 'mv_none');
			mv_util.rmClass(mv_fruit, 'mv_none');
			mv_util.rmClass(mv_begin, 'mv_none');
		});

		btnstart.addEventListener(defaultClick, function () {
			bGameStart = true;
			bStopTiming = false;
			mv_stats({
				category: 'Richmedia',
				action: 'click_fallobj_start',
				label: data.width + '_' + data.height
			});
		});

		close_btn.addEventListener(defaultClick, function () {
			console.log(aTimeout);

			var mv_falling = mv_util.getEl('#mv_falling');
			mv_falling && mv_util.rmEl(mv_falling);

			mv_util.rmClass(banner, 'mv_none');
			mv_util.addClass(mv_fruit, 'mv_none');
			mv_util.addClass(mv_begin, 'mv_none');

			if (data && !mv_common.getTplSize(data)) {
				// 游戏永久关闭
				clearInterval(gameTimer);
			}

			bStopTiming = true;
			// 重新初始化
			resetGame();
			gameStart();

		});

		try {
			mraid.addEventListener("stateChange", function (state) {
				if (state === 'expanded') {
					mv_util.addClass(banner, 'mv_none');
				} else {
					resetGame();
					gameStart();
					mv_util.rmClass(banner, 'mv_none');
				}
			});
		} catch (e) {

		}

	}

	var gameTimer;

	function gameStart() {
		gameInit(function (stage) {
			// 初始化后再显示开始按钮
			mv_util.rmClass(mv_util.getEl('.mv_btn_start')[0], 'mv_none');
			clearInterval(gameTimer);
			gameTimer = setInterval(function () {
				debug && console.log('waiting 4 game start...');
				if (bGameStart) {
					clearInterval(gameTimer);
					var mv_falling = mv_util.getEl('#mv_falling');
					debug && console.log('game start...');
					mv_falling && mv_util.rmClass(mv_util.getEl('#mv_falling'), 'mv_none');
					mv_util.rmClass(mv_util.getEl('.mv_game')[0], 'mv_none');
					mv_util.addClass(mv_util.getEl('.mv_begin')[0], 'mv_none');
					renderTime(duration);
					generateObj(stage, function () {
						debug && console.log('game end...');
						// 结束
						bStopGenerateObj = true;
						var scoreEl = mv_util.getEl('.mv_score');
						for (var i = 0; i < scoreEl.length; i++) {
							scoreEl[i].innerHTML = score;
						}
						gameOverAnimation(1);
					});
				}
			}, 200);
		});
	}

	function gameInit(cb) {
		// Create new app
		Stage(function (stage, canvas) {
			mv_util.attr(canvas, 'id', 'mv_falling');
			canvas.style.backgroundImage = 'url(' + mv_data.backgroud + ')';

			mv_util.addClass(canvas, 'mv_falling_bg');
			mv_util.addClass(canvas, 'mv_none');

			try {
				var oExpand = mraid.getExpandProperties();
				ww = oExpand.width;
				wh = oExpand.height;
			} catch (e) {
				ww = mv_util.getWindowWidth() || 414;
				wh = mv_util.getWindowHeight() || 736;
			}
			// Set view box
			stage.viewbox(ww, wh);
			_generateStageImg();
			cb && cb(stage);
		});

		function _generateStageImg() {
			for (var i = 0; i < imgLen; i++) {
				var str = 'img_' + i;
				oScoreMap[str] = 100 * (i + 1);
				var obj = {};
				obj[str] = {
					x: 0,
					y: 0,
					width: 221,
					height: 221
				}
				Stage({
					image: imgList[i],
					textures: obj
				});
			}
		}

	}

	function generateObj(stage, cb) {
		var obj;
		var durationTimer;
		durationTimer = setInterval(function () {
			debug && console.log('duration: ', duration);
			renderTime();
			renderScore();
			if(bStopTiming){
				clearInterval(durationTimer);
				duration = 20;
				score = 0;
				return;
			}
			if (duration > 0) {
				duration--;
			} else {
				clearInterval(durationTimer);
				cb && cb();
			}
		}, 1000);

		_create();
		var _time;
		function _create() {
			count++;
			_time = mv_util.rnd(280, 900);
			setTimeout(function () {
				var str = 'img_' + mv_util.rnd(0, imgLen);
				obj = Stage.image(str).appendTo(stage);
				var objOffsetX = mv_util.rnd(0, ww - 100);
				obj.pin({
						offsetX: objOffsetX,
						offsetY: 0
					})
					.scaleTo(100, 100)
					.tween(2000)
					.ease('linear')
					.pin({
						offsetY: wh
					})
				_bindObjEvent(stage, obj, str);
				if (!bStopGenerateObj) {
					_create();
				}
			}, _time);
		}

		function _bindObjEvent(stage, obj, img) {
			obj.on(Mouse.START, function (point) {
				var me = this;
				if (img.substr(img.length - 1, img.length) == (imgLen - 1)) {
					duration = 0;
					bomb();
					return;
				}
				var clickscore = Number(oScoreMap[img]);
				score += clickscore;
				renderClickScore(clickscore);
				renderScore();
				me.remove();
			});
		}

	}


	// 游戏重置
	function resetGame() {
		// 初始化参数
		score = 0;
		duration = 20;
		count = 0;
		bGameStart = false;
		bStopGenerateObj = false;

		renderScore();

		// 清除所有动画的定时器
		_.each(aTimeout, function (item) {
			clearTimeout(item);
		});

		// 初始化`dom`元素状态
		var mv_game = mv_util.getEl('.mv_game')[0];
		var gameover = mv_util.getEl('.mv_gameover')[0];
		var txt = mv_util.getEl('.mv_gameover_txt')[0];

		_.each([
			mv_game,
			gameover,
			txt
		], function (item) {
			mv_util.addClass(item, 'mv_none');
		});

		mv_util.addClass(gameover, 'mv_start');

		// lastpage animation reset
		var lastscorebox = mv_util.getEl('.mv_lastscorebox')[0];
		var sharebox = mv_util.getEl('.mv_sharebox')[0];
		var install = mv_util.getEl('.mv_install')[0];
		_.each([
			lastscorebox,
			sharebox,
			install,
			txt
		], function(item){
			mv_util.rmClass(item, 'mv_fadein');
		});

	}


	function mv_stats(cfg) {
		mv_common.gpStats(function () {
			var mv_ga = mv_util.getEl('#mv_ga');
			var param = mv_ga.getAttribute('data-param');
			param = JSON.parse(param);

			ga('set', {
				dimension1: param['offer'],
				dimension2: param['app'],
				dimension3: param['advertiser']
			});

			ga('send', {
				title: document.title,
				hitType: 'event',
				eventCategory: cfg.category, // 'Richmedia'
				eventAction: cfg.action, // 'Click_falling_banner'
				eventLabel: cfg.label // mv_data.width + mv_data.height
			});
		});
	}

	//调启ga统计
	mv_common.gpStats();
	
})(window);












